import { useUserData } from "@me8eon/react_authentication";

export const useFirstName = () => {
    const { name, firstName } = useUserData();
    const nameArray = name?.split(",") ?? [];
    const fName = firstName || nameArray[1] || nameArray[0];
    return fName;
};
